import { ProtocolIcon } from './chunk-OA43R2O7.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ProtocolCardTitle({ protocolId, icon, label }) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: label })
  ] });
}

export { ProtocolCardTitle };
//# sourceMappingURL=chunk-JOEPYPII.js.map
//# sourceMappingURL=chunk-JOEPYPII.js.map